// Pillar manifest — the four disciplines rendered on Home.tsx.
// Mirrors the shape/pattern of data/blog-posts.ts:
//   - typed interface
//   - exported const array
//   - getPillars() helper for consistency
//
// To add or edit a pillar:
//   1. Update the Pillar entry below.
//   2. If a new accent color is needed, add the token in theme.ts (theme.other)
//      and reference it here by NAME — never hardcode hex.

import type { Icon } from "@tabler/icons-react";
import {
  IconCode,
  IconMusic,
  IconCamera,
  IconBulb,
} from "@tabler/icons-react";

export interface Pillar {
  label: string;
  heading: string;
  meta: string;
  body: string;
  href: string;
  icon: Icon;
  /** Name of a token in theme.other (e.g. "pillarTech"). Consumer looks up via theme.other[accentColor]. */
  accentColor: string;
  /** Name of a token in theme.other used for accent TEXT — may differ from accentColor for AA contrast (e.g. Think). */
  accentTextColor: string;
  /** Destination-specific CTA verb + noun rendered in the pillar card arrow row. */
  cta: string;
}

export const pillars: Pillar[] = [
  {
    label: "Build",
    heading: "Tech",
    meta: "Rails · React · n8n · AI",
    body: "Automation systems, full-stack apps, and AI integrations for organizations.",
    href: "/tech",
    icon: IconCode,
    accentColor: "pillarTech",
    accentTextColor: "pillarTech",
    cta: "See the projects",
  },
  {
    label: "Move",
    heading: "Dance",
    meta: "Urban Kiz · Since 2014",
    body: "Teaching, traveling, producing — a decade in Austin's Kizomba scene and beyond.",
    href: "/dance",
    icon: IconMusic,
    accentColor: "pillarDance",
    accentTextColor: "pillarDance",
    cta: "Meet the practice",
  },
  {
    label: "Capture",
    heading: "Media",
    meta: "Event photography · Video",
    body: "Live moments, concerts, and the people who make up Austin's creative scene.",
    href: "/media",
    icon: IconCamera,
    accentColor: "pillarMedia",
    accentTextColor: "pillarMedia",
    cta: "View the gallery",
  },
  {
    label: "Reflect",
    heading: "Think",
    meta: "Culture · Systems · Self",
    body: "Essays on race, community, systems thinking, and the ideas connecting all of it.",
    href: "/think",
    icon: IconBulb,
    // pillarThink is decorative-only (fails AA for text); pair with pillarThinkAccessible for text.
    accentColor: "pillarThink",
    accentTextColor: "pillarThinkAccessible",
    cta: "Read the essays",
  },
];

// ── Helpers ──────────────────────────────────────────────────────────────────

export function getPillars(): Pillar[] {
  return pillars;
}
